import { Locale } from "@linkfluence/models/locale";
import { FullFacet } from "@radarly/models/facets";
import { Towns } from "@radarly/models/geo";
export interface ClauseRepo {
  getBrandLogos(values: (number | string)[]): Promise<FullFacet["values"]>;
  getCelebrities(values: (number | string)[]): Promise<FullFacet["values"]>;
  getOccupations(
    ids: (number | string)[],
    locale: Locale
  ): Promise<FullFacet["values"]>;
  getTowns(
    values: (number | string)[],
    projectID: number,
    locale: Locale
  ): Promise<Towns>;
}

export const ClauseRepositoryUID = Symbol("Radarly/ClauseRepository");
